import React from 'react'
import styled from 'styled-components'
import arrow from '../assets/Images/arrow.png'
import { useNavigate, useLocation } from "react-router-dom";
import { motion, useAnimation } from "framer-motion";

const Power = styled.button`
position: fixed;
top: 2rem;
left: 50.4%;
transform: translateX(-50%);

background-color: #FCF6F4;
border-radius: 50%;
border: 1px solid #000;
width: 2.4rem;
height: 2.4rem;

display: flex;
justify-content: center;
align-items: center;

padding: 0;
cursor: pointer;
z-index: 10;

transition: background-color 0.3s ease-in-out,
            box-shadow 0.3s ease-in-out,
            transform 0.2s ease-in-out;

&:hover {
  background-color: rgba(0, 0, 0, 0.05);
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.18);
}

&:active {
  transform: translateX(-50%) scale(0.95);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
}
`;

const Overlay = styled(motion.div)`
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: white;
z-index: 9999;
pointer-events: none;
`;

const PowerButton = () => {

  const navigate = useNavigate();
  const controls = useAnimation();
  const location = useLocation();

const handleBack = async () => {

  // already home → do nothing
  if (location.pathname === "/") {
    return;
  }

  await controls.start({
    opacity: 2,
    transition: { duration: 0.6 }
  });

  navigate("/");
};

  return (
    <>
      <Overlay
        initial={{ opacity: 0 }}
        animate={controls}
      />
      <Power onClick={handleBack}>
        <img src={arrow} alt="arrow" width={24} height={24} />
      </Power>
    </>
  )
}

export default PowerButton